import {PROMO_CODE_EMAIL_URL, PROMO_REDEEM_PROMO_CODE_URL, PROMO_CODE_VERIFY_USER} from './constants';
import useAxios from '../hooks/useAxios';

/**
 * Hook for interacting with the Promo Code API.
 *
 * @returns {Object} An object containing functions to interact with the API.
 */
export const usePromoCodeApi = () => {
  const api = useAxios();

  /**
   * Posts a request to the Promo Code API for email promo code.
   *
   * @returns {Promise} A Promise that resolves when the request is complete.
   */
  const postEmailPromoCode = () => api.post(PROMO_CODE_EMAIL_URL);

  /**
   * Posts a request to redeem a promo code.
   *
   * @param {string} promoCode - The promo code to redeem.
   * @returns {Promise} A Promise that resolves when the request is complete.
   */
  const postRedeemPromoCode = promoCode => api.post(PROMO_REDEEM_PROMO_CODE_URL, {code: promoCode});

  /**
   * Gets information to verify the user for promo code.
   *
   * @returns {Promise} A Promise that resolves with user verification information.
   */
  const getVerifyUser = () => api.get(PROMO_CODE_VERIFY_USER);

  return {
    postEmailPromoCode,
    postRedeemPromoCode,
    getVerifyUser,
  };
};
